import { MsalAuthenticationProvider } from "./MsalAuthenticationProvider";
import { ServiceClient } from "./client/ServiceClient";
import { msalInstance } from "./msal";

const msalAuthenticationProvider = new MsalAuthenticationProvider(msalInstance);

export const serviceClient = new ServiceClient("/api", msalAuthenticationProvider);